<template>
  <div class="container-login">
    <div class="input-line">
      <div class="inout-pram">姓名</div>
      <div class="input-phone">
        <input
          type="text"
          placeholder="请输入姓名"
          :value="name"
          @input="handelChange(100, 'name', $event)"
        />
      </div>
    </div>
    <!-- <div class="input-line">
      <div class="inout-pram">年龄</div>
      <div class="input-phone">
        <input
          type="text"
          placeholder="请输入年龄"
          :value="age"
          @input="handelChange(3, 'age', $event)"
        />
      </div>
    </div> -->
    <div class="input-line">
      <div class="inout-pram">身份证号</div>
      <div class="input-phone">
        <input
          type="text"
          placeholder="请输入身份证号"
          :value="id_number"
          @input="handelChange(18, 'id_number', $event)"
        />
      </div>
    </div>
    <div class="input-line">
      <div class="inout-pram">手机</div>
      <div class="input-phone">
        <input
          type="text"
          placeholder="请输入手机号"
          :value="phone"
          @input="handelChange(11, 'phone', $event)"
        />
      </div>
    </div>
    <div class="input-line">
      <div class="inout-pram">密码</div>
      <div class="input-phone">
        <input
          type="text"
          placeholder="请输入密码"
          :value="password"
          @input="handelChange(11, 'password', $event)"
        />
      </div>
    </div>

    <span :class="['btn-login', { disable: isFromDisable }]" @click="registered"
      >注册</span
    >
    <div></div>
  </div>
</template>


<script>
import util from "../common/util.js";
import actions from "../common/actions.js";
export default {
  data() {
    return {
      name: "",
      age: "",
      sex: "",
      id_number: "",
      phone: "",
      password: "",
      captcha: "",
      isFromDisable: false,
      isCaptchaDisable: true,
      isTimerStart: false,
      count: 90,
      remoteCaptcha: "",
    };
  },
  created() {
    this.$store.commit("changeTitle", "注册");
    util.hideLoading();
  },
  beforeDestroy() {
    clearTimeout(this.Daojishi);
  },
  methods: {
    handelChange(length, key, event) {
      let value = event.target.value;
      let newValue = value.length > length ? value.slice(0, length) : value;
      event.target.value = newValue;
      this[key] = newValue;
      //   this.checkForm();
    },
    getCaptcha() {
      this.isCaptchaDisable = true;
      if (this.isTimerStart) return;
      actions.getHtDx({ phone: this.phone }).then((res) => {
        if (res.is_success == 0) {
          this.isTimerStart = true;
          this.remoteCaptcha = res.content;
          this.timer();
        }
      });
    },
    checkForm() {
      if (this.mame == "") {
        alert("请先输入姓名");
        return false;
      }
      if (this.id_number == "") {
        alert("请先输入身份证号");
        return false;
      }
      if (this.password == "") {
        alert("请先输入密码");
        return false;
      }
    },
    registered() {
       if (this.mame == "") {
        alert("请先输入姓名");
        return false;
      }
      if (this.id_number == "") {
        alert("请先输入身份证号");
        return false;
      }
      if (this.password == "") {
        alert("请先输入密码");
        return false;
      }
      let data = {
        name: this.name,
        // age: this.age,
        id_number: this.id_number,
        phone: this.phone,
        password: this.password,
        gzhid:util.getLocalStorage('openid')
      };
      console.log(data);
        actions.registered_active(data).then((res) => {
           this.$router.push('/personcenter');
        });
           
    },
    timer: function () {
      this.Daojishi = setTimeout(() => {
        if (this.count == 0) {
          this.isTimerStart = false;
        } else {
          this.count--;
          this.timer();
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.container-login {
  position: relative;
  padding: 1rem 0.3rem 0;
  .input-phone {
    display: inline-block;
    width: 5rem;
    position: relative;
    padding-bottom: 0.2rem;
    > input {
      width: 100%;
      height: 1rem;
      border: 1px solid #eee;
      text-align: center;
      font-size: 0.28rem;
    }
  }
  .input-captcha {
    position: relative;
    padding-bottom: 0.6rem;
    > input {
      width: 100%;
      height: 1rem;
      border: 1px solid #eee;
      text-align: center;
      font-size: 0.28rem;
      width: 4.4rem;
    }
    .btn-captcha {
      position: absolute;
      right: 0;
      top: 0;
      width: 2.3rem;
      height: 1rem;
      line-height: 1rem;
      font-size: 0.28rem;
      color: #fff;
      background-color: #ecb94c;
      text-align: center;
      &.disable {
        background-color: #ecb94c;
      }
    }
  }
  .btn-login {
    display: block;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.36rem;
    color: #fff;
    background-color: #ecb94c;
    text-align: center;
    &.disable {
      pointer-events: none;
      background-color: #ecb94c;
    }
  }
  .inout-pram {
    width: 1.5rem;
    display: inline-block;
  }
}
</style>
